import { render, staticRenderFns } from "./ViewerRecord.vue?vue&type=template&id=7e8d869f&scoped=true&"
import script from "./ViewerRecord.vue?vue&type=script&lang=js&"
export * from "./ViewerRecord.vue?vue&type=script&lang=js&"
import style0 from "./ViewerRecord.vue?vue&type=style&index=0&id=7e8d869f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8d869f",
  null
  
)

export default component.exports